import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AppRoutes from './routes/appRoutes';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AuthContextProvider from './contexts/authContext';
import './styles/app.css';

const theme = createTheme(
    {
        palette: {
            mode: 'light',
            primary: {
                main: '#1d1d1d',
            },
            secondary: {
                main: '#fff',
            },
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 500,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        },
    },
    esES
);

const App = () => {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <AuthContextProvider>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={
                            process.env.REACT_APP_CAPTCHA_KEY as string
                        }
                    >
                        <AppRoutes />
                    </GoogleReCaptchaProvider>
                </AuthContextProvider>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
